import type { BillablePrice, FeatureData, UnsupportedBillablePrice } from '../types'

export interface PricePlanTemplate {
  id: string
  name: string
  externalName: string
  features: FeatureData[]
  billables: (BillablePrice | UnsupportedBillablePrice)[]
  numberOfConnections: number
  eligibility: Eligibility
}

export enum BillingFrequency {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export enum SupportType {
  ALL = 'ALL',
  NONE = 'NONE',
  SPECIFIC = 'SPECIFIC',
}

export type Partner = string & { readonly Partner: unique symbol }
export type Currency = string & { readonly Currency: unique symbol }
export type Country = string & { readonly Country: unique symbol }

export interface PartnerSupport {
  type: SupportType
  values?: Partner[]
}

export interface CurrencySupport {
  type: SupportType
  values?: Currency[]
}

export interface CountrySupport {
  type: SupportType
  values?: Country[]
}

export interface Eligibility {
  partners: PartnerSupport | undefined
  currencies: CurrencySupport | undefined
  countries: CountrySupport | undefined
  billingFrequency: BillingFrequency
}

export type CreateTemplateFormData = {
  name: string
  externalName: string
  eligibility: Eligibility
  copyFromExisting: boolean
  templateToCopy: string
  navigateToTemplate: boolean
}

export enum ChannelType {
  AGENCY = 'AGENCY',
  PARTNER = 'PARTNER',
}

export type DefaultConfigChannel = {
  type: ChannelType
  channelId: string
}

export type DefaultConfig = {
  id: string
  channel: DefaultConfigChannel
  templateId: string
  currencySupport: {
    type: SupportType
    currencies?: string[]
  }
}

export type CreateDefaultConfigFormData = {
  channel: DefaultConfigChannel
  templateId: string
  currencySupport: {
    type: SupportType
    currencies?: string[]
  }
}

export type CreateTemplateDialogProps = {
  isOpen: boolean
  onClose: () => void
  onSave: (template: CreateTemplateFormData) => Promise<void>
  onError?: (error: Error) => void
}

export interface EditDialogProps {
  isOpen: boolean
  onClose: () => void
  onSave: () => void
  title: string
  isDisabled: boolean
  children: React.ReactNode
}
